const modulesConfigs = [];

export default modulesConfigs;
